import { useCallback } from 'react';

import { useAppearanceSaves } from '../../contexts/appearance-saves';
import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// The Appearance switch in Settings (C27): Device, Light or Dark, saved with
// the account the moment one is picked, with no save button. What it shows,
// and the save under way or failed, are the account's appearance saves
// (#136), not this screen's: leaving Settings and coming back shows the same
// choice, and the page turns once the service has acknowledged it
// (components/apply-appearance).
//
// The radios are never disabled while saving, because disabling the one a
// keyboard user just moved to would drop their focus. A refused save puts the
// stored choice back and says why; one whose answer was lost keeps the choice
// with Try again, since it may well be stored already.
export function Appearance() {
  const { text, translate } = useLanguage();
  const { chosen, failure, uncertain, choose, retry } = useAppearanceSaves();

  const onChange = useCallback(function({ currentTarget }) {
    choose(currentTarget.value);
  }, [ choose ]);

  const options = [ 'DEVICE', 'LIGHT', 'DARK' ].map(function(key) {
    return (
      <label key={ key } className={ styles.option }>
        <input className={ styles.radio } type='radio' name='appearance' value={ key } checked={ chosen === key } onChange={ onChange }/>

        { text.appearances[ key ] }
      </label>
    );
  });

  let hint = text.appearanceChosenHint;

  if (chosen === 'DEVICE') {
    hint = text.appearanceDeviceHint;
  }

  let message = null;

  if (failure != null) {
    let again = null;

    if (uncertain === true) {
      again = <button className={ styles.again } type='button' onClick={ retry }>{ text.tryAgain }</button>;
    }

    message = (
      <div className={ styles.error } role='alert'>
        <span>{ translate(failure) }</span>

        { again }
      </div>
    );
  }

  return (
    <section className={ styles.card }>
      <fieldset className={ styles.group } aria-describedby='appearance-hint'>
        <legend className={ styles.legend }>{ text.appearance }</legend>

        <div className={ styles.options }>{ options }</div>
      </fieldset>

      <span id='appearance-hint' className={ styles.hint }>{ hint }</span>

      { message }
    </section>
  );
}
